import groupsMetaReducer from './groupsMetaReducer';

export default groupsMetaReducer;
